import { InputText } from '@ui/src';
import { BrandImagesTypes } from './types';

import cn from './styles.module.css';

const BrandImages = ({
  setValue,
  cardLogo,
  headerLogo,
  favicon,
  loaderIcon,
}: BrandImagesTypes) => (
  <div className={cn.brandImagesWrapper}>
    <div className={cn.brandColorsTitle}>Brand images</div>
    <div className={cn.brandColorsHint}>Choose images for your brand.</div>
    <div className={cn.brandImageWrapper}>
      <InputText
        name="headerLogo"
        value={headerLogo}
        placeholder="Enter link..."
        onChange={(e) => setValue('headerLogo', e.target.value)}
        title="Header Logo"
      />
      <div
        className={`${cn.brandImagePreview} ${
          !headerLogo ? cn.brandImagePreviewEmpty : ''
        }`}
      >
        {!headerLogo && (
          <div className={cn.empty}>Add Header Logo (svg, png)</div>
        )}
        {headerLogo && <img src={headerLogo} alt="Header Logo Preview" />}
      </div>
    </div>
    <div className={cn.brandImageWrapper}>
      <InputText
        name="favicon"
        value={favicon}
        placeholder="Enter link..."
        onChange={(e) => setValue('favicon', e.target.value)}
        title="Favicon"
      />
      <div
        className={`${cn.brandImagePreview} ${
          !favicon ? cn.brandImagePreviewEmpty : ''
        }`}
      >
        {!favicon && <div className={cn.empty}>Add Favicon (svg, png)</div>}
        {favicon && <img src={favicon} alt="Favicon Preview" />}
      </div>
    </div>
    <div className={cn.brandImageWrapper}>
      <InputText
        name="cardLogo"
        value={cardLogo}
        placeholder="Enter link..."
        onChange={(e) => setValue('cardLogo', e.target.value)}
        title="Card Logo"
      />
      <div
        className={`${cn.brandImagePreview} ${
          !cardLogo ? cn.brandImagePreviewEmpty : ''
        }`}
      >
        {!cardLogo && <div className={cn.empty}>Add Card Logo (svg, png)</div>}
        {cardLogo && <img src={cardLogo} alt="Card Logo Preview" />}
      </div>
    </div>
    <div className={cn.brandImageWrapper}>
      <InputText
        name="loaderIcon"
        value={loaderIcon}
        placeholder="Enter link..."
        onChange={(e) => setValue('loaderIcon', e.target.value)}
        title="Loader Icon"
      />
      <div
        className={`${cn.brandImagePreview} ${
          !loaderIcon ? cn.brandImagePreviewEmpty : ''
        }`}
      >
        {!loaderIcon && (
          <div className={cn.empty}>Add Loader Icon (svg, png)</div>
        )}
        {loaderIcon && <img src={loaderIcon} alt="Loader Icon Preview" />}
      </div>
    </div>
  </div>
);

export default BrandImages;
